import React, { ReactNode } from 'react';
import { RichText } from 'src/components/RichText/RichText';
import { Modal } from 'src/components/Modal/Modal';
import { ProductGalleryProvider } from 'src/components/ProductDetail/ProductGallery';
import { updateMediaEntries } from 'src/MixAndMatchBundle/MixAndMatchImageGallery';
import { MediaEntry } from 'src/types/global-types';

import { ModalHeader } from './ModalHeader';
import { ProductGallery } from './ProductGallery';
import classes from './ProductDetail.scss';

type Props = {
    isOpenProductInfoModal: boolean;
    closeProductInfoModal: () => void;
    delivery?: ReactNode | null;
    additionalMediaEntry?: MediaEntry;
    description?: string;
    is24HourDelivery: boolean;
    canCustomise: boolean;
    mediaEntires: MediaEntry[];
    productName: string;
};

export const ModalProductInfo: React.FC<Props> = ({
    isOpenProductInfoModal,
    closeProductInfoModal,
    delivery,
    additionalMediaEntry,
    description,
    is24HourDelivery,
    canCustomise,
    mediaEntires,
    productName,
}) => {
    const displayedMedia = additionalMediaEntry
        ? updateMediaEntries([additionalMediaEntry, ...mediaEntires])
        : updateMediaEntries(mediaEntires);

    return (
        <Modal
            className={classes.productInformation}
            type="popup"
            isOpen={isOpenProductInfoModal}
            onDismiss={closeProductInfoModal}
        >
            <ModalHeader title={productName} closeModal={closeProductInfoModal} />
            <div className={classes.productDetailModal}>
                <ProductGalleryProvider media_entries={displayedMedia}>
                    <ProductGallery
                        name={productName}
                        deliveryIcon={is24HourDelivery}
                        canCustomise={canCustomise}
                        modalGallery
                    />
                </ProductGalleryProvider>
                {description && (
                    <div className={classes.productInformationDescription}>
                        <p className={classes.productInfoHeader}>Product Info</p>
                        <RichText content={description} />
                    </div>
                )}
                {delivery}
            </div>
        </Modal>
    );
};
